import React from "react";
import { Stack } from "react-bootstrap";
import { Label } from "reactstrap";
import { formatDate } from "../../utils/helpers";
import { useTranslation } from "react-i18next";

export const AddressDate = ({ contract }) => {
  const { t, i18n } = useTranslation();

  return (
    <li className="list-group-item">
      <div className="d-flex justify-content-between align-items-start">
        <div className="flex-grow-1">
          <div className="fw-bold mb-1">
            {contract?.id + " - " + contract?.address || "-"}
          </div>

          <Stack direction="horizontal" gap={3} className="mb-3">
            <Stack gap={1} className="mb-3">
              <Label className="fw-bold" for="fromDate">
                {t("CONTRACT_START_DATE")}
              </Label>
              {/* start date */}
              {contract?.contract_start_date
                ? formatDate(
                    contract?.contract_start_date,
                    i18n.language,
                    "DD-MM-YYYY"
                  )
                : "-"}
            </Stack>
            <Stack gap={1} className="mb-3">
              <Label className="fw-bold" for="toDate">
                {t("CONTRACT_END_DATE")}
              </Label>
              {contract?.contract_end_date
                ? formatDate(
                    contract?.contract_end_date,
                    i18n.language,
                    "DD-MM-YYYY"
                  )
                : "-"}
            </Stack>
          </Stack>
        </div>
      </div>
    </li>
  );
};
